import {WithPermissionModel} from '../../../permission/api/entity/withPermission.model';

export class TagSummaryModel extends WithPermissionModel {
    id: number;
    name: string;
    color: string;
}
